import { AccessRuleCode } from 'constants/entities';
import { ReactComponent as CircleIcon } from 'images/newIcons/circle.svg';
import { ReactComponent as FolderIcon } from 'images/newIcons/folder.svg';
import { ReactComponent as FolderPrivateClosedIcon } from 'images/newIcons/folderPrivateClosed.svg';
import { ReactComponent as FolderPrivateOpenedIcon } from 'images/newIcons/folderPrivateOpened.svg';
import { ReactComponent as FolderReadonlyIcon } from 'images/newIcons/folderReadonly.svg';

import { EntityNode } from './types';

export const renderNodeIcon = ({ data, isOpen }: EntityNode) => {
  const {
    isFolder,
    entity: { isPersonalSpace, accessType },
  } = data;

  if (!isFolder) return <CircleIcon className="w-full h-full" />;

  if (accessType <= AccessRuleCode.READONLY)
    return <FolderReadonlyIcon className="w-full h-full" />;

  if (isPersonalSpace)
    return isOpen ? <FolderPrivateOpenedIcon /> : <FolderPrivateClosedIcon />;

  return <FolderIcon className="w-full h-full" />;
};
